<template>
<div>
<div class="container" style="bottom: 52px" @touchstart="scrollStart" @touchmove="scrollMove" @touchend="scrollEnd">
  <div class="fixed-top" :class="siteGray">
    <img v-if="topBgImg" class="fixed-top-bg" :src='topBgImg' />
    <img v-else class="fixed-top-bg" src='/clientmodule/distVueCli/newHomeVue/img/top_bg.png' />
    <top v-if="topFixedMap['CD00000001']" :item="topFixedMap['CD00000001']" />
    <classify v-show="scrollEndStatus" v-if="topFixedMap['CD00000050']" :item="topFixedMap['CD00000050']" />
  </div>
  <div style="position: relative;overflow: hidden;">
    <img v-if="contentBgImg" class="fixed-content-bg" :class="siteGray" :src='contentBgImg' />
    <div class="height124" :class="siteGray"></div>
    <div v-for="(item,index) in homeList" :key="index">
      <div class="floating-adv" v-if="item.columnDefineId == 'CD00000042' && item.adList && item.adHrefUrl && item.imgUrl" @click="clickFloatAd(item.adList,item.columnDefineId)"><img :src="item.imgUrl" /></div>
      <goldArea v-if="item.columnDefineId == 'CD00000024'" :item="item" :class="siteGray"/>
      <newCustom v-if="showNewCustom && item.columnDefineId == 'CD00000025'" :item="item" :class="siteGray" />
      <swiperAd v-if="item.columnDefineId == 'CD00000015' || item.columnDefineId == 'CD00000016'" :item="item" :class="siteGray" />
      <swiperY v-if="item.columnDefineId == 'CD00000023'" :item="item" :class="siteGray" />
      <flashSale v-if="item.columnDefineId == 'CD00000010' && item.flashInfo.prodList.length > 0" :item="item" :class="siteGray" />
      <fourGrids v-if="item.columnDefineId == 'CD00000017'" :item="item" :class="siteGray" />
      <fourClassify v-if="item.columnDefineId == 'CD00000003' && item.templateNo == 'AD_1_5_0'" :item="item" :class="siteGray" />
      <brand v-if="item.columnDefineId == 'CD00000020'" :item="item" :class="siteGray" />
      <adFourProd v-if="item.columnDefineId == 'CD00000003' && item.templateNo == 'MIX_07_0'" :item="item" :class="siteGray" />
      <slideProd v-if="item.columnDefineId == 'CD00000003' && item.templateNo == 'PR_1_1_3'" :item="item" :class="siteGray" />
      <guessLike v-if="item.columnDefineId == 'CD00000022'" :item="item" />
    </div>
  </div>
  <div v-if="prodAdvertising.status" class="popup-prod-ad" :class="siteGray">
    <img @click="toProdAd" class="popup-prod-ad-img" :src='prodAdvertising.imgUrl' />
    <div @click="closeProdAd" class="popup-prod-ad-close"></div>
  </div>
  <publicToast v-if="publicToast.show" />
</div>
<div v-if="backTopStatus" @click="backTop()" class="back-top" :class="siteGray"></div>
</div>
</template>

<script>
import Top from './top.vue';
import Classify from './classify.vue';
import GoldArea from './goldArea.vue';
import SwiperAd from './swiperAd.vue';
import FlashSale from './flashSale.vue';
import FourGrids from './fourGrids.vue';
import GuessLike from './guessLike.vue';
import FourClassify from './fourClassify.vue';
import Brand from './brand.vue';
import AdFourProd from './adFourProd.vue';
import SlideProd from './slideProd.vue';
import PublicToast from './publicToast.vue';
import NewCustom from './newCustom.vue';
import SwiperY from './swiperY.vue';
import axios from 'axios';
export default { 
  name: 'Container',
  data() {
    return {
      prodAdvertising: {
        status: false,
        imgUrl: '',
        adHref: ''
      },
      backTopStatus: false,
      scrollTimer: '',
      scrollRecord: '',
      scrollMoveStatus: false,
      siteGray: []
    }
  },
  components: {
    Top,Classify,GoldArea,SwiperAd,FlashSale,FourGrids,GuessLike,FourClassify,Brand,AdFourProd,SlideProd,PublicToast,NewCustom,SwiperY
  },
  computed: {
    contentBgImgStyle(){
      var obj = {}
      if(this.contentBgImg){
        obj={
          'background': '#f7f7f7 url(' + this.contentBgImg + ') no-repeat',
          'background-size': '100%'
        }
      }
			return obj
    },
    columnMargin(){
      var obj = {}
      if(this.item.marginObj){
        obj={
          'margin-top': this.item.marginObj.top,
          'margin-bottom': this.item.marginObj.bottom
        }
      }
			return obj
    },
    topBgImg: function(){
      return this.$store.state.home.topBgImg
    },
    contentBgImg: function(){
      return this.$store.state.home.contentBgImg[this.$store.state.home.pageId]
    },
    topFixedMap: function(){
      return this.$store.state.home.topFixedMap
    },
    scrollEndStatus: function(){
      return this.$store.state.home.scrollEndStatus
    },
    homeList: function(){
      var self = this;
      setTimeout(function() {
        self.initDrag()
      });
      return this.$store.state.home.homeAllList[this.$store.state.home.pageId]
    },
    publicToast: function(){
      return this.$store.state.home.publicToast
    },
    showNewCustom: function(){
      return this.$store.state.home.showNewCustom
    },
  },
  created: function () {
    if(!document.referrer && clientTools.isWeiXin()){
      window.history.pushState("","","#");
    };
    var previewTime = clientTools.getQueryString('previewTime');
    previewTime && (clientTools.setCookie('SecPreviewTime',previewTime));
    if(clientTools.getCookie('ccb-main')){
      // this.$store.dispatch('getUserCooQuery',{type: '1'})
      this.$store.dispatch('userInfoQuery',{})
    }else{
      this.$store.commit('setShowNewCustom',true)
    }
    this.$store.dispatch('getAjaxBase',{pageId: '90005'})
    this.$store.dispatch('getHotKeyList',{})
    this.getProdAdvertising()
  },
  mounted: function(){
    var self = this
    $('.container').scroll(function(){
      self.scrollMoveStatus = $('.container').scrollTop() > 1
      $('.container').scrollTop() < 1 && self.$store.commit('setScrollEndStatus',true);
      if($('.container').scrollTop() > 300){
        self.backTopStatus = true
      }else{
        self.backTopStatus = false
      }
    })
    if (nowDate.getTime() < publicGrayTime) {
      this.siteGray.push('site-gray')
    }
  },
  methods: {
    initDrag(){
      $('.floating-adv').drag(function(ev,dd) {
        var _header = $(".fixed-top")
        var _bottom = $(".container").height() - $(".floating-adv").height()
        if (dd.offsetY<=_header.outerHeight() || dd.offsetY>=_bottom) return;
        $(this).css({top:dd.offsetY, transition:''})
      })
    },
    clickFloatAd(obj,id){
      this.$store.commit('doTrack',{
        href: obj.adHrefUrl,
        columnDefineId: id,
        ccId: obj.ccId,
        adId: obj.adId,
        adName: obj.adName,
        idType: 'ad'
      });
      window.location.href = obj.adHrefUrl;
    },
    scrollStart(e){
      this.scrollMoveStatus = false
    },
    scrollMove(e){
      this.scrollMoveStatus && this.$store.commit('setScrollEndStatus',false)
    },
    scrollEnd(){
      var self = this
      this.scrollRecord = $('.container').scrollTop()
      if(!this.scrollEndStatus){
        this.doScrollEndOperation()
      }
      // this.$store.commit('setScrollEndStatus',true)
    },
    doScrollEndOperation(){
      var self = this
      clearTimeout(this.scrollTimer)
      this.scrollTimer = setTimeout(function(){
        if(self.scrollRecord == $('.container').scrollTop()){
          self.$store.commit('setScrollEndStatus',true)
        }else{
          console.log('in timer')
          self.scrollRecord = $('.container').scrollTop()
          self.doScrollEndOperation()
        }
      },100)
    },
    getProdAdvertising(){
      var self = this
      if(sessionStorage.getItem('hideAdvertising') != 'yes'){
        var data = new FormData();
        data.append('pageId', '90005')
        axios.post('/client/popAdvertAjax.jhtml',data).then(function (res) {
          if (res.data.resultCode == '0' && res.data.result) {
            self.prodAdvertising.adHref = res.data.result.popupUrl
            self.prodAdvertising.imgUrl = res.data.result.popupAdImgUrl
            self.prodAdvertising.status = true
            sessionStorage.setItem('hideAdvertising','yes');
          }
        })
      }
    },
    toProdAd(){
      window.location.href = this.prodAdvertising.adHref
    },
    closeProdAd(){
      this.prodAdvertising.status = false
    },
    backTop(){
      $('.container').animate({scrollTop:0},800)
    },
  }
}
</script>

<style scoped>
.fixed-top{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 9;
  overflow: hidden;
  background: #fff;
}
.fixed-top-bg{
  width: 100%;
  display: block;
  z-index: -1;
  position: absolute;
  left: 0;
  top: 0;
}
.fixed-content-bg{
  width: 100%;
  display: block;
  z-index: -1;
  position: fixed;
  left: 0;
  top: 0;
}
.back-top{
  position: fixed;
  right: 10px;
  bottom: 70px;
  width: 45px;
  height: 45px;
  background: url(/client/images/go_top.png) no-repeat center;
  background-size: 38px;
}
.container{
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 52px;
  font-size: 14px;
  color: #333;
  background: #f7f7f7;
  /* padding-top: 124px; */
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}
.height124{
  height: 124px
}
.popup-prod-ad{
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0,0,0,0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999999;
  flex-direction: column;
}
.popup-prod-ad-img{
  width: 80%;
  max-height: 50vh;
  display: block;
  object-fit: contain;
}
.popup-prod-ad-close{
  background: url(/public/images/close-btn.png) no-repeat center;
  background-size: 50%;
  margin-top: 20px;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  border: 1px solid #fff;
}
.floating-adv {
    position: fixed;
    max-width: 107px;
    right: 0;
    top: 50%;
    z-index: 10;
    text-align: right;
}
.floating-adv img {
    width: 100%;
}
</style>